import { LangObjectArray } from "@brg/api/dist/api-core/utils/lang-utils";

export const MAX_DOCS_COUNT = 5;

export enum FormType {
    base = 0,
    custom = 1,

}
export type FormField = {
    type: FormFieldType;
    header: LangObjectArray ;
    placeholder: LangObjectArray;
    isRequired: boolean;
    inlineVariants: LangObjectArray[];
    fieldIdInCrm: number;
    isTagInCrm: boolean;
    isDisabled: boolean;
    url?: string;
    additionalInfo?: Record<string, any>;
}

export enum FormFieldType {
    Text = 0,
    Comment = 1,
    Mail = 2,
    Phone = 3,
    SelectOne = 4,
    File = 5,
    Name = 6,
    Surname = 7,
    SelectMultiple = 8,
    Telegram = 9,
    AdditionalMail = 10,
    Date = 11,
    LegalDocument = 12,
    Education = 13,
}import { LangObjectArray } from "@brg/api/dist/api-core/utils/lang-utils";

export const MAX_DOCS_COUNT = 5;

export enum FormType {
    base = 0,
    custom = 1,

}
export type FormField = {
    type: FormFieldType;
    header: LangObjectArray ;
    placeholder: LangObjectArray;
    isRequired: boolean;
    inlineVariants: LangObjectArray[];
    fieldIdInCrm: number;
    isTagInCrm: boolean;
    isDisabled: boolean;
    url?: string;
    additionalInfo?: Record<string, any>;
}

export enum FormFieldType {
    Text = 0,
    Comment = 1,
    Mail = 2,
    Phone = 3,
    SelectOne = 4,
    File = 5,
    Name = 6,
    Surname = 7,
    SelectMultiple = 8,
    Telegram = 9,
    AdditionalMail = 10,
    Date = 11,
    LegalDocument = 12,
    Education = 13,
}